import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { Subscription } from "rxjs";
import {
  CatalogCategoryViewModel,
  ProductViewModelBase,
} from "src/domain/client";
import { ChannelRequestService } from "src/services/channel-request.service";
import { ProductService } from "src/services/product.service";

@Component({
  selector: "vw-popular-products",
  templateUrl: "./popular-products.component.html",
})
export class PopularProductsComponent implements OnInit, OnDestroy {
  @Input() catalogCategory?: CatalogCategoryViewModel;
  @Input() productCarouselBackgroundColor: boolean = false;

  popularProducts: ProductViewModelBase[] = [];

  private channelRequestUpdatesSubscription?: Subscription;

  constructor(
    private channelRequestService: ChannelRequestService,
    private productService: ProductService,
  ) {}

  ngOnInit(): void {
    this.channelRequestUpdatesSubscription =
      this.channelRequestService.channelRequestUpdated$.subscribe(() => {
        this.getPopularProducts(
          this.catalogCategory && this.catalogCategory.catalogCategoryId,
        );
      });

    this.getPopularProducts(
      this.catalogCategory && this.catalogCategory.catalogCategoryId,
    );
  }

  ngOnDestroy(): void {
    this.channelRequestUpdatesSubscription?.unsubscribe();
  }

  //////////

  private getPopularProducts(categoryId?: number): void {
    this.productService
      .getPopularProducts(categoryId)
      .then((products) => {
        this.popularProducts = products;
      })
      .catch(() => {});
  }
}
